// extracted by mini-css-extract-plugin
module.exports = {"root":"_1k-225zyhhCnMo4JyV-h3O"};